import React, { useRef, useState} from "react";
import { Button, Input, Select, Table, Modal, Divider } from "antd";

import "./index.css";
import { FilterOutlined } from "@ant-design/icons";

const Option = Select.Option;



function FilteredTable({ headers, data , currentData=null,pageSize=25 }) {
  const [filteredData, setFilteredData] = useState(data);
  const [filterValues, setFilterValues] = useState({});
  const [filterTypes, setFilterTypes] = useState({});
  


  function handelTableChange(pagination, filters, sorter, extra) {
    const { currentDataSource } = extra;
    
    currentData(currentDataSource);
  }

  

  const handleFilterChange = (column, value) => {
    setFilterValues({
      ...filterValues,
      [column.dataIndex]: value,
    });
    // filterData(column, value, filterTypes[column.dataIndex]);
  };

  const handleTypeChange = (column, value,) => {
    setFilterTypes({
      ...filterTypes,
      [column.dataIndex]: value,
    });
    // filterData(column.dataIndex, filterValues[column.dataIndex], value);
  };

  const filterData = (column, value, type) => {
    let filtered = [...data];

    if (value !== undefined && value !== "") {
      switch (type) {
        case "equal":
          filtered = filtered.filter((item) => item[column.dataIndex] === value);
          break;
        case "notEqual":
          filtered = filtered.filter((item) => item[column.dataIndex] !== value);
          break;
        case "greaterThan":
          filtered = filtered.filter((item) => item[column.dataIndex] > value);
          break;
        case "smallerThan":
          filtered = filtered.filter((item) => item[column.dataIndex] < value);
          break;
        case "contains":
          filtered = filtered.filter((item) =>
            String(item[column.dataIndex]).includes(value)
          );
          break;
        default:
          break;
      }
    }

    setFilteredData(filtered);
  };
  const handleReset = () => {
    setFilterValues({});
    setFilterTypes({});
    setFilteredData(data);
  };
  const columns = headers.map((header) => {
    const response = {
      title: header.title,
      dataIndex: header.dataIndex,
      key: header.key,
    };
    if (header.sort) {
      response.sorter = (a, b) => a[header.dataIndex] - b[header.dataIndex];
    }
    
    if (header.search) {
      response.filterDropdown = ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`جستوجو ${header.title}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {handleFilterChange(header, selectedKeys[0]);confirm();}}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Select
            style={{ width: "100%" }}
            value={filterTypes[header.dataIndex] || "equal"}
            onChange={(value) => handleTypeChange(header, value)}
          >
            <Option value="equal">برابر باشد</Option>
            <Option value="notEqual">برابر نباشد</Option>
            <Option value="greaterThan">بزرگتر از</Option>
            <Option value="smallerThan">کوچکتر از</Option>
            <Option value="contains">شامل باشد</Option>
          </Select>
          <div style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => {handleFilterChange(header, selectedKeys[0]);confirm();}}
              icon={<FilterOutlined />}
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              جستوجو
            </Button>
            <Button onClick={()=>{handleReset();clearFilters();confirm()}} size="small" style={{ width: 90 }}>
              ریست
            </Button>
          </div>
        </div>
      );
      response.onFilter = (value, record) => {
        const columnValue = record[header.dataIndex];
        if(header.num) {
          switch (filterTypes[header.dataIndex]) {
            case "equal":
              console.log(1);
              return columnValue === parseInt(value);
            case "notEqual":
                console.log(2);
              return columnValue !== parseInt(value);
            case "greaterThan":
                console.log(3);
              return columnValue > parseInt(value);
            case "smallerThan":
              console.log(4);
              return columnValue < parseInt(value);
            case "contains":
              console.log(5);
              return String(columnValue).includes(value);
            default:
              console.log(6);
              return columnValue === parseInt(value);
          }
        }else{
          switch (filterTypes[header.dataIndex]) {
            case "equal":
              console.log(1);
              return String(columnValue) === value;
            case "notEqual":
                console.log(2);
              return String(columnValue) !== value;
            case "greaterThan":
                console.log(3);
              return String(columnValue) > value;
            case "smallerThan":
              console.log(4);
              return String(columnValue) < value;
            case "contains":
              console.log(5);
              return String(columnValue).includes(value);
            default:
              console.log(6);
              return true;
          }
        }
        
      };
    }
    if (header.render) {
      response.render = header.render;
    }
    return response;
  });
  return (
    <Table
      columns={columns}
      dataSource={filteredData}
      size="small"
      bordered
      pagination={{ pageSize: pageSize }}
      onChange={handelTableChange}
    />
  );
}

export default FilteredTable;
